'use strict';

var chip = require('../../../../../../../../../../_virtual/chip.cjs');

var hasRequiredChip;

function requireChip () {
	if (hasRequiredChip) return chip.__exports;
	hasRequiredChip = 1;

	var CHIP_VARIANTS = /*#__PURE__*/ function(CHIP_VARIANTS) {
	    CHIP_VARIANTS["single"] = "single";
	    CHIP_VARIANTS["multi"] = "multi";
	    return CHIP_VARIANTS;
	}({});

	chip.__exports.CHIP_VARIANTS = CHIP_VARIANTS;
	
	return chip.__exports;
}

exports.__require = requireChip;
//# sourceMappingURL=chip.cjs.map
